<script>
    import { onMount } from "svelte";
    import { push } from "svelte-spa-router";
    onMount(() => {
        setTimeout(() => {
            push("/home");
        }, 300);
    });
</script>

Logging you in...
